<template>
  <div class='h-mml-xybox'>
    <p v-if='resp.data.Data && resp.data.Data[0]' style='padding:0px;margin:0px;'>
      {{getProcess(resp.data.Data[0].Progress)}}</p>
  </div>
</template>

<script>
export default {
  name: 'ShowProgress',
  props: {
    resp: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    getProcess(process) {
      const num = parseInt(process, 16);
      if (num && /^[-+]?\d+$/.test(num)) {
        return `${num}%`;
      }
      return process;
    }
  }
};
</script>

<style>

</style>